import { render, staticRenderFns } from "./MinimumOrderQuantityForm.vue?vue&type=template&id=6043d7fb"
import script from "./MinimumOrderQuantityForm.vue?vue&type=script&lang=js"
export * from "./MinimumOrderQuantityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports